import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { apiCall } from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

interface ImportDraftArgs {
  draftId: string;
}

const ENDPOINT = `${APIConfiguration.import}drafts/imported`;

export default async function importDraft(
  payload: ImportDraftArgs,
): Promise<BaseBackResponse> {
  const response = await apiCall(ENDPOINT, {
    method: SUPPORTED_METHODS.POST,
    json: payload,
  });

  if (response.failure) {
    throw new Error(`Got an exception trying to import draft`);
  }

  return response;
}
